import { render } from "./WarehouseOverview.vue?vue&type=template&id=5b2bee12"
import script from "./WarehouseOverview.vue?vue&type=script&lang=js"
export * from "./WarehouseOverview.vue?vue&type=script&lang=js"

import "./WarehouseOverview.vue?vue&type=style&index=0&id=5b2bee12&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__